module.exports = __webpack_public_path__ + "img/anonymous_profile_pic.a2033833.png";